/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const StampListPage = lazyLoad(
  () => import('./index'),
  module => module.StampListPage
);
